var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--main"
  }, [_c('main-visual', {
    attrs: {
      "code": "main-pc",
      "sites": "yknowledge",
      "pc": ""
    }
  }), _c('main-visual', {
    attrs: {
      "code": "main-mobile",
      "sites": "yknowledge",
      "mobile": ""
    }
  }), _c('div', {
    staticClass: "main-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main-banner__con"
  }, [_c('div', {
    staticClass: "main-banner__tit",
    staticStyle: {
      "line-height": "1"
    }
  }, [_vm._v("이음자문"), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "0.5em"
    }
  }, [_vm._v("(온라인 질의응답)")])]), _c('div', {
    staticClass: "main-banner__img"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-banner-process.png",
      "alt": "01질의등록>02그룹지정>03답변등록>04추가질의응답>05자문종료"
    }
  })])])])]), _c('div', {
    staticClass: "main-advice"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "advice-items"
  }, [_c('router-link', {
    staticClass: "advice-item",
    attrs: {
      "to": "/join/type"
    }
  }, [_c('div', {
    staticClass: "advice-item__inner"
  }, [_c('div', {
    staticClass: "advice-item__con"
  }, [_c('i', {
    staticClass: "icon icon-short"
  }), _c('h3', {
    staticClass: "text-28 text-lg-22 text-md-18"
  }, [_vm._v("회원가입")])])])]), _c('router-link', {
    staticClass: "advice-item",
    attrs: {
      "to": "/counsel/short"
    }
  }, [_c('div', {
    staticClass: "advice-item__inner"
  }, [_c('div', {
    staticClass: "advice-item__con"
  }, [_c('i', {
    staticClass: "icon icon-long"
  }), _c('h3', {
    staticClass: "text-28 text-lg-22 text-md-18"
  }, [_vm._v("이음자문")])])])])], 1)])]), _c('section', {
    staticClass: "main-section main-section--board"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row main-board-row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('main-notice')], 1), _c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('main-reference')], 1)])])]), _c('main-summary'), _c('div', {
    staticClass: "main-logo"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "main-logo__inner"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-logo2.png",
      "alt": "이미지"
    }
  })])], 1)]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "main-logo__inner"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-logo3.png",
      "alt": "이미지"
    }
  })])], 1)]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "main-logo__inner"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-logo4.png",
      "alt": "이미지"
    }
  })])], 1)]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "main-logo__inner"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-logo5.png",
      "alt": "이미지"
    }
  })])], 1)]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "main-logo__inner"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-logo6.png",
      "alt": "이미지"
    }
  })])], 1)]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "main-logo__inner"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-logo7.png",
      "alt": "이미지"
    }
  })])], 1)]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "main-logo__inner"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-logo8.png",
      "alt": "이미지"
    }
  })])], 1)])])])]), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }